import React from 'react';
import classes from './Spinner.module.css'

/**
 * Created by Doa on 2-8-2019.
 */
const spinner = (props) => (
    <div className={classes.Loader}>Loading...</div>
    );

export default spinner;